<span class="ds-menu-item" [class.disabled]="item.disabled">{{item.text | translate}}</span>
